<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Update Preference</h1>
          <div class="title">
            <span>What is your rate per hour?</span>
          </div>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
        </div>
      </div>
    <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
      :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
      <el-form-item label="Rate per hour" prop="minRate" :required='true'>
        <div class="el-input el-input--prefix">
          <el-input type="number" v-model="formsData.userForm.minRate.value" :placeholder="'0.00'"
            @blur="checkFormValidation('userForm', true, 'minRate')">
          </el-input>
          <span class="el-input__prefix">$</span>
        </div>
      </el-form-item>
      <el-form-item label="Weekend rate per hour" prop="weekendRate" :required='true'>
        <div class="el-input el-input--prefix">
          <el-input type="number" v-model="formsData.userForm.weekendRate.value"
            :disabled="formsData.userForm.weekendRate.disabled" :placeholder="'0.00'"
            @blur="checkFormValidation('userForm', true, 'weekendRate')">
          </el-input>
          <span class="el-input__prefix">$</span>
        </div>
      </el-form-item>
      <el-form-item class="button_submit button_submit-top mb0">
        <el-button class="submit" type="blue" @click="goNext('userForm')" :disabled="formsData.userForm.disabled">
          Continue <i class="el-icon-right"></i>
        </el-button>
      </el-form-item>
    </el-form>
    <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
  </div>
</div>
</template>
  
<script>
import { onMounted, inject } from "vue";
import { ElMessage } from "@/components/Vendor/Element";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import SvgIcon from '@/components/Svg/SvgIcon.vue';

addIcons({
  "arrow-back-outline": arrowBackOutline,
});

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const routeName = $route.name;
    const userData = $store.getters.GET_USER_DATA;
    const setPageClassGlobal = inject("setPageClassGlobal");

    const formsDataArray = {
      userForm: {
        minRate: {
          value: userData?.minRate || null,
          resetValue: true,
          validators: [{
            validator: (rule, formField, callback) => {
              formValidate.validate(rule, formField, 'minRate', callback, setFormValidation);
            },
          }]
        },
        weekendRate: {
          value: userData?.weekendRate || null,
          resetValue: true,
          validators: [{
            validator: (rule, formField, callback) => {
              formValidate.validate(rule, formField, 'weekendRate', callback, setFormValidation);
            },
          }]
        },
      }
    };

    const goBack = () => {
      $router.push({
        name: "profile",
      });

    };

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              const response = await $store.dispatch("SAVE_INTERNAL_POOL_USER_PERFERENCE", getFormValues(formName));
              if (response.success) {
                ElMessage({
                  type: "success",
                  message: response.message,
                });
              } else {
                ElMessage({
                  type: "error",
                  message: response.message,
                });
              }
              $router.push({
                name: 'profile',
              })
            } catch (error) {
              console.log('error submit!!');
              console.log(error);
            }
          })();
        } else {
          console.log('error submit!!');
          return false;
        }

      });
    };

    onMounted(() => {
      setPageClassGlobal("global_agency_notes_page");
      setFormRefs();
      formsRefs.userForm.value.$el[0].focus();
      checkFormValidation('userForm', false);
    });

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      goBack,
      formsData,
      checkFormValidation,
      setFormValidation,
      routeName,
      goNext,
    };
  },
};
</script>
  